import { Component, OnInit, AfterViewInit } from '@angular/core';
import { AnalyticsService } from '@box-core/services';
import { LandingChain } from '@box-types';
import { Router } from '@angular/router';
import { LandingPageService } from './landing-page.service';
import { PromoBannerDetailsDialogResponse } from '@box-core/components/promo-banner-details-dialog/promo-banner-details-dialog.types';

@Component({
  selector: 'landing-page',
  templateUrl: './landing.page.html',
  styleUrls: ['./landing.page.scss'],
  providers: [LandingPageService]
})
export class LandingPage implements OnInit, AfterViewInit {
  public foodLandingChains: LandingChain[];
  public groceriesLandingChains: LandingChain[];

  constructor(
    private router: Router,
    private analyticsService: AnalyticsService,
    private landingPageService: LandingPageService
  ) {}

  ngOnInit(): void {
    this.landingPageService.setMetaTags();
    window.localStorage.removeItem('Box:returnURL');
    this.foodLandingChains = this.landingPageService.getFoodLandingChains();
    this.groceriesLandingChains = this.landingPageService.getGroceriesLandingChains();
    // todo refactor
    this.landingPageService.handlePromoBanners().subscribe((response: PromoBannerDetailsDialogResponse) => {
      if (response?.triggerAction) return;
      this.landingPageService.handleRedirectionSequence();
    });
  }

  ngAfterViewInit(): void {
    this.pageViewGAEvent('Landing Page', this.router.url);
  }

  private pageViewGAEvent(name: string, url: string): void {
    this.analyticsService.addGACustomEvent('page_view', { name, url });
  }
}
